import { getCookie, getBrowserLanguage } from "@Common";

export default ({ isHMR, app, store, route }: { [propName: string]: any }) => {
  if (process.server || isHMR) return; // 是否是通过模块热替换 webpack hot module replacement (仅在客户端以 dev 模式)
  const locale = route.query.language || getBrowserLanguage() || getCookie("language") || app.i18n.fallbackLocale || "en";

  let language = locale

  language = language.toLowerCase();
  if (language.includes("zh-hans") || language === "zh" || language === "cn") {
    // 简体中文 || （==='cn'）修复安卓bug
    language = "zh";
  } else if (language.includes("zh-hant") || language.includes("zh-hk") || language.includes("zh-mo")) {
    // 繁体中文
    language = "tw";
  } else {
    language = language.split("-")[0].split("_")[0];
  }

  if (store.getters.GET_LOCAL !== locale) {
    store.dispatch("SET_LOCAL", language);
    app.i18n.locale = language;
  }
};
